module.exports = __webpack_public_path__ + "img/r_game_images_03.a5e899b5.png";